import axios, { AxiosResponse } from "axios";
import { IWorkorder } from "../models/workorder";
import { IWorkOrderSOR } from "../models/workordersor";
import { INote } from "../models/note";
import { IVariation } from "../models/variation";
import { ILoginResponse } from "../models/loginresponse";
import { IVariationResponse } from "../models/variationresponse";
import { Iappointments } from "../models/appointments";

// import React, {useState, useEffect} from 'react';


// const[posts, setPosts] = useState([]);
// const[loading, setLoading] = useState(false);
// const[currentPage, setCurrentPage] = useState(1);
// const[postsPerPage, setPostsPerPage] = useState(10);

// useEffect(() => {
//   const fetchPosts = async () => {
//     setLoading(true);
//     const res = await axios.post('https://gilmartins-portal-api-test.azurewebsites.net')
//     setPosts(res.data);
//     setLoading(false);
//   }

//   fetchPosts();
// }, []);

// const indexOfLastPost = currentPage * postsPerPage;
// const indexOfFirstPost = indexOfLastPost - postsPerPage;
// const currentPosts = posts.slice(indexOfFirstPost, indexOfLastPost)


// const Posts = ({ posts, loading}) => {
//   if (loading) {
//     return;
//   }
//   return{posts.map(post => (
    
//   ))}
// }

//  axios.defaults.baseURL = "http://localhost:63787/"
//axios.defaults.baseURL = "https://gilm-clientportal-test.azurewebsites.net/"

import config from './apiconfig';

axios.defaults.baseURL = config.app.baseUrl

const responseBody = (response: AxiosResponse) => response.data;


const requests = {
  get: (url: string) => axios.get(url).then(responseBody),
  post: (url: string, body: object) => axios.post(url, body).then(responseBody),
  put: (url: string, body: object) => axios.put(url, body).then(responseBody),
  delete: (url: string) => axios.delete(url).then(responseBody)
};
 

const Workorders = {
  list: (body: object): Promise<IWorkorder[]> =>
     requests.post("/CP/WorkOrders/GetWorkOrders", body)
};

const WorkOrderSORS = {
  list: (body: object): Promise<IWorkOrderSOR[]> =>
    requests.post("/CP/SORActivity/GetSORActivity", body)
};

const AgedDebt = {
  list: (body: object):  Promise<IWorkorder[]> =>
    requests.post("/CP/Debt/RetrieveAgedDebtWorkorders", body)
};

const WorkOrderNotes = {
  
  list: (body: object): Promise<INote[]> =>
    requests.post("/CP/Notes/GetSORActivity", body)
};

const WorkOrderVariationHistory = {
  list: (body: object): Promise<IVariation[]> =>
    requests.post("CP/Variations/GetVariationHistory", body)
};

const Variations = {
  SetApproval: (body: object): Promise<IVariationResponse> =>
    requests.post("CP/Variations/SetApprovalStatus", body)
};

const UserAuth = {
  Login: (body:object): Promise<ILoginResponse>=>
  requests.post("/CP/Auth/AuthenticateUser",body)
}

const Appointments = {
  list: (body: object): Promise<Iappointments[]>=>
  requests.post("/CP/Appointment/GetAppointments", body)
}

export default {
  Workorders,
  WorkOrderSORS,
  WorkOrderNotes,
  WorkOrderVariationHistory,
  Variations,
  UserAuth,
  Appointments,
  AgedDebt
  
};
